import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { AttachPartsToOptionBody } from '../Models/Part';

@Injectable()
export class OptionService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getOptionItem(optionId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/option/' + optionId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getOption(gridData = new HttpParams(), scope = 'backoffice') {

    return this.http.get<any>(environment.apiUrl + '/' + scope + '/option/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }




  public manageOption(option, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/option/' + id, option)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/option/', option)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
  public manageSubOption(option, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/option/sub-option/' + id, option)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/option/sub-option/', option)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public softDeleteOption(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/option/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/option/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setParentPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/option/sub-option/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getPriceMultiplier(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/option/price-multiplier/list?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public readdOption(id) {
    return this.http.put(environment.apiUrl + '/backoffice/option/' + id + '/reAdd', {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getDeletedOptionsOfAnOption(id, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/option/' + id + '/deleted-options')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  /**
   *  Get options list based on product model and style
   *  Style parameter is optional and required for models with style
   *
   * @param productId number
   * @param modelId number
   * @param styleId number|null
   * @param scope string
   */
  public getOptionByProductModelStyle(productId, modelId, styleId = null, scope = 'dealer-system') {
    let url = environment.apiUrl + '/' + scope + '/option/' + productId + '/' + modelId;
    if (styleId !== null) {
      url += '/' + styleId;
    }
    return this.http.get<any>(url)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getPerProductOptionByProductModelStyle(productId, modelId, styleId = null, scope = 'dealer-system') {
    let url = environment.apiUrl + '/' + scope + '/option/per-product/' + productId + '/' + modelId;
    if (styleId !== null) {
      url += '/' + styleId;
    }
    return this.http.get<any>(url)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getOptionByPackageProduct (packageProductId, scope = 'dealer-system') {
    const url = environment.apiUrl + '/' + scope + '/option/package-product/' + packageProductId;
    return this.http.get<any>(url)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public attachPartsToOption(body: AttachPartsToOptionBody, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/part/option/' + id + '/attach-parts' , body)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public detachPartsFromOption(partId: number, id = null) {
    return this.http.delete(environment.apiUrl + '/backoffice/part/' + partId + '/detach-option/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
